import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'components';

function RadioButton({
  children,
  dataTest,
  description,
  id,
  name,
  isChecked,
  isDisabled,
  onChange,
  value,
}) {
  return (
    <div className="flex-start flex space-x-2 py-2">
      <div>
        <input
          className="h-4 w-4 appearance-none rounded-full border border-solid border-gray bg-white checked:border-[5px] checked:border-green disabled:opacity-50"
          data-testid={dataTest}
          type="radio"
          id={id}
          name={name}
          checked={isChecked}
          disabled={isDisabled}
          onChange={onChange}
          value={value}
        />
      </div>
      <div className={`flex-col ${isDisabled ? 'opacity-50' : 'opacity-100'}`}>
        <label className="text-sm text-night-rider" htmlFor={id}>
          {children}
        </label>
        {description ? <Text>{description}</Text> : null}
      </div>
    </div>
  );
}

RadioButton.propTypes = {
  children: PropTypes.string.isRequired,
  dataTest: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

RadioButton.defaultProps = {
  dataTest: 'radio',
  description: undefined,
  isChecked: false,
  isDisabled: false,
};

export default RadioButton;
